import { NotificationsViewModel } from '@ail/notifications-api'
import './LastActivities.scss'
import ActivityItem from './ActivityItem/ActivityItem'
import { useCallback, useMemo, useState } from 'react'
import { Pagination } from '../../common/Pagination/Pagination'
import { useLazyGetNotificationsQuery } from '../../../redux/api/notificationsApi'
import CheckToggle from '../../common/CheckToggle/CheckToggle'

interface Props {
  onClose: () => void
  data: NotificationsViewModel
  totalCount: number
  iconGetter: (templateName?: string) => string
}
interface FetchParams {
  count: number
  page: number
  templateNames?: string[]
}
export default function FullViewLastActivities({ totalCount, data, iconGetter }: Props) {
  const itemsPerPage = 10
  const [currentPage, setCurrentPage] = useState(0)
  const [fetchNotifications, newNotifications] = useLazyGetNotificationsQuery()
  const [alertsOnly, setAlertsOnly] = useState(false)

  const totalPages = useMemo(() => {
    return newNotifications.data
      ? Math.ceil(newNotifications.data.totalCount / itemsPerPage)
      : Math.ceil(totalCount / itemsPerPage)
  }, [newNotifications.data, totalCount])

  function getAlertsOnly(value: boolean) {
    setAlertsOnly(value)
    if (value) {
      fetchNotifications({ templateNames: ['ReportAvailable'] })
    } else {
      fetchNotifications({})
    }
  }

  const handleNextPage = useCallback(() => {
    const nextPage = currentPage + 1
    setCurrentPage(nextPage)
    const params: FetchParams = { count: itemsPerPage, page: nextPage + 1 }
    if (alertsOnly) {
      params.templateNames = ['ReportAvailable']
    }
    fetchNotifications(params)
  }, [alertsOnly, currentPage, fetchNotifications])

  const handlePrevPage = useCallback(() => {
    const prevPage = currentPage - 1
    if (prevPage >= 0) {
      setCurrentPage(prevPage)
      const params: FetchParams = { count: itemsPerPage, page: prevPage + 1 }
      if (alertsOnly) {
        params.templateNames = ['ReportAvailable']
      }
      fetchNotifications(params)
    }
  }, [alertsOnly, currentPage, fetchNotifications])

  const handleSetPage = useCallback(
    (page: number) => {
      setCurrentPage(page)
      const params: FetchParams = { count: itemsPerPage, page: page + 1 }
      if (alertsOnly) {
        params.templateNames = ['ReportAvailable']
      }
      fetchNotifications(params)
    },
    [alertsOnly, fetchNotifications]
  )
  return (
    <div className="fullView lastActivities">
      <div className="toggle-grouping-wrap">
        <div className="toolArea">
          {
            //! enable later when functionality is ready
            /* <div className="selectArea">
            <select className="filterByYear">
              <option className="filterByYearOptions">All</option>
              <option className="filterByYearOptions">2021</option>
              <option className="filterByYearOptions">2023</option>
              <option className="filterByYearOptions">2022</option>
              <option className="filterByYearOptions">2020</option>
            </select>
            <i className="icon-bottom" />
          </div>
          <div className="input-area">
            <input type="search" className="transparent" defaultValue="" />
            <i className="icon-search" />
          </div> */
          }
        </div>
        <div className="alertSection">
          <CheckToggle onClick={getAlertsOnly} />
          <label>Alert Only</label>
          <i className="icon icon-warning"></i>
        </div>
      </div>
      <ul className="activityList">
        {(newNotifications.data?.notifications ?? data.notifications).map((n) => (
          <ActivityItem item={n} icon={iconGetter(n.templateName)} />
        ))}
      </ul>

      <Pagination
        currentPage={currentPage}
        pageCount={totalPages}
        prevPage={handlePrevPage}
        nextPage={handleNextPage}
        setPage={handleSetPage}
        offset={2}
      />
    </div>
  )
}
